import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Reusable mode picker card (for forward mode, pricing source, allocation source).
export default function ModeCard({ icon, title, description, tag, tagColor = 'success', selected, onClick, disabled, fullWidth, sx }) {
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      sx={{
        position: 'relative',
        flex: fullWidth ? '1 1 100%' : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        borderRadius: 2,
        border: (t) => `1.5px solid ${selected ? t.palette.primary.main : t.palette.divider}`,
        bgcolor: (t) => (selected ? alpha(t.palette.primary.main, 0.05) : 'background.paper'),
        p: 1.75,
        transition: 'all 0.12s',
        '&:hover': disabled
          ? {}
          : {
              borderColor: (t) => t.palette.primary.light,
              bgcolor: (t) => alpha(t.palette.primary.main, 0.03),
            },
        ...sx,
      }}
    >
      {selected && (
        <CheckCircleIcon
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'primary.main',
            fontSize: 20,
          }}
        />
      )}
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
        {icon ? <span style={{ marginRight: 6 }}>{icon}</span> : null}
        {title}
      </Typography>
      <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.45 }}>
        {description}
      </Typography>
      {tag ? (
        <Chip
          size="small"
          label={tag}
          sx={{
            mt: 1,
            height: 20,
            fontSize: 10,
            fontWeight: 600,
            bgcolor: (t) => alpha(t.palette[tagColor]?.main || t.palette.success.main, 0.16),
            color: (t) => t.palette[tagColor]?.dark || t.palette.success.dark,
          }}
        />
      ) : null}
    </Box>
  );
}
